// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createActionsHook,
	type Action,
	type BoundActions,
	type HookActionsFunction,
	type HookFunction,
} from '@atlassian/react-sweet-state';

type ModalOpenState = { isOpen: boolean };

const openActions = {
	setOpen:
		(isOpen: boolean): Action<ModalOpenState> =>
		({ setState }) => {
			setState({ isOpen });
		},
} as const;

const openStore = createStore<ModalOpenState, typeof openActions>({
	name: 'IssueViewModalOpenState',
	initialState: { isOpen: false },
	actions: openActions,
});

export const useIsIssueViewModalOpen: HookFunction<
	boolean,
	BoundActions<
		ModalOpenState,
		{
			readonly setOpen: (isOpen: boolean) => Action<ModalOpenState>;
		}
	>,
	undefined
> = createHook<ModalOpenState, typeof openActions, boolean, undefined>(openStore, {
	selector: (state) => state.isOpen,
});

export const useIssueViewModalOpenActions: HookActionsFunction<
	BoundActions<
		ModalOpenState,
		{
			readonly setOpen: (isOpen: boolean) => Action<ModalOpenState>;
		}
	>
> = createActionsHook(openStore);

type ModalReadyState = { isReady: boolean };

const readyActions = {
	setReady:
		(isReady: boolean): Action<ModalReadyState> =>
		({ setState }) => {
			setState({ isReady });
		},
} as const;

const readyStore = createStore<ModalReadyState, typeof readyActions>({
	name: 'IssueViewModalReadyState',
	initialState: { isReady: false },
	actions: readyActions,
});

export const useIsIssueViewModalReady: HookFunction<
	boolean,
	BoundActions<
		ModalReadyState,
		{
			readonly setReady: (isReady: boolean) => Action<ModalReadyState>;
		}
	>,
	undefined
> = createHook<ModalReadyState, typeof readyActions, boolean, undefined>(readyStore, {
	selector: (state) => state.isReady,
});

export const useIssueViewModalReadyActions: HookActionsFunction<
	BoundActions<
		ModalReadyState,
		{
			readonly setReady: (isReady: boolean) => Action<ModalReadyState>;
		}
	>
> = createActionsHook(readyStore);
